/**
 * Runs the external handler, then the internal one — unless the first cancelled
 * the event, in which case the second never runs.
 *
 * The names describe the usual arrangement, where a component lets its caller
 * opt out of some default behaviour of its own. The order is what actually
 * decides, though, so a component whose behaviour is a gate the caller must not
 * slip past passes itself first and its caller second.
 *
 * `internal` is optional so such a gate still runs when there is nothing to gate
 * — a button with no `onClick` of its own still has to refuse a press.
 */
export const composeEventHandlers = <Event extends React.SyntheticEvent>(
  external: ((event: Event) => void) | undefined,
  internal?: (event: Event) => void
): ((event: Event) => void) => {
  return function (event) {
    external?.(event)

    if (!event.defaultPrevented) {
      internal?.(event)
      return
    }
  }
}
